export default __webpack_public_path__ + "static/media/limit_35.c0deebc7.svg";